import React, { useState, useContext } from 'react'
import { fetchUrl } from 'modules/util/functions'
import { useNavigate } from 'react-router-dom'
import { UserContext } from 'modules/contexts/UserContext'
import * as BrowserStorage from 'modules/BrowserStorage'

const Login = () => {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState();
	const { setUser } = useContext(UserContext);
	const navigate = useNavigate();
	document.title = "Ingresar - Bal Solutions";

	const hanelEmailChange = (e) => {
		setEmail(e.target.value);
	}

	const hanelPasswordChange = (e) => {
		setPassword(e.target.value);
	}

	const handleSubmit = (e) => {
		e.preventDefault();

		if (!email || !password) {
			setError('Debe completar los campos');
			return;
		}

		fetchUrl("/login/login", "post", {
			nombreUsuario: email,
			contraseña: password
		}, {
			success: (r) => {
				// Persist user in local storage
				BrowserStorage.set("user", r.data);

				// Set in context
				setUser(r.data);

				navigate("/crm");
			},
			error: (r) => {
				setError(r.errorMessage);
			}
		});
	}

	return (
		<main role="main">

			<section role="banner" id="inicio" className="bg-light section">

				<div className="container">

					<div className="d-flex justify-content-center">

						<div className="col-12 col-md-5 py-5">

							<div className="br-12 bg-white mb-3 box-shadow">

								<div className="p-4 p-md-5">

									<h1 className="text-normal-dos text-dark bold mb-4 text-center">
										Ingresar
									</h1>

									{error && <div style={{ marginBottom: "10px" }} className="text-danger">{error}</div>}


									<div className="row" id="wp_login_form">

										<div className="col-12">

											<form onSubmit={handleSubmit} name="custom-login-form" id="custom-login-form">
												<p className="login-username">
													<label for="user_login">Correo electrónico:</label>
													<input
														type="text"
														name="log"
														id="user_login"
														autocomplete="username"
														className="form-control text-dark border-dark py-2"
														onChange={hanelEmailChange} />
												</p>

												<p className="login-password">
													<label for="user_pass">Contraseña:</label>
													<input
														type="password"
														name="pwd"
														id="user_pass"
														autocomplete="current-password"
														spellcheck="false"
														className="form-control text-dark border-dark py-2"
														required=""
														size="20"
														onChange={hanelPasswordChange} />
												</p>

												{/* <p className="login-remember">
													<label>
														<input name="rememberme" type="checkbox" id="rememberme" value="forever" /> Recuérdame
													</label>
												</p> */}

												<p className="form-group text-center" >
													<input type="submit" name="wp-submit" id="wp-submit" className="btn btn-primary rounded-5" value="Acceder" style={{ marginTop: "25px" }} />
													{/* <input type="hidden" name="redirect_to" value="http://localhost/wordpress/crm" /> */}
												</p>

											</form>

										</div>
									</div>

								</div>

							</div>

						</div>

					</div>

				</div>

			</section>

		</main>
	)
}

export default Login;